
export interface Beneficiario {
    nombre?: string
    parentesco?: string
    tipoDoc?: string
    numDoc: string
}
export interface Titular {
    nombre?: string
    tipoDoc?: string
    numDoc?: string
    parentesco?: string
}

export interface DataBack {
    content?: string | DataBack;
    titular?: Titular;
    datosBasicos?: {
        primerNombre?: string;
        segundoNombre?: string
        primerApellido?: string;
        segundoApellido?: string

    };
    parentesco?: { tipoParentesco?: string };
    identidad?: { numero?: string; tipo?: string };
}

export class SolicitudesUtil {
    private static readonly ESTADOS_MAP: Record<string, string> = {
        '1': 'En Trámite',
        '2': 'Con Observación',
        '3': 'Con Observación',
        '4': 'Rechazado',
        '5': 'En Trámite',
        '6': 'En Trámite',
        '7': 'En Trámite',
        '8': 'Aprobado',
        '9': 'En Trámite',
        '10': 'Aprobado'
    };

    public static homologarEstado(estado: string | number): string {
        const key = estado ? estado.toString() : '';
        return this.ESTADOS_MAP[key] || 'Estado desconocido'
    }

    private static readonly DOCUMENT_TIPODOC_TITULAR: Record<string, string> = {
        'CO1C': 'Cédula de ciudadanía',
        'CO1T': 'Tarjeta de identidad',
        'CO1D': 'Carnet Diplomático',
        'CO1E': 'Cédula de Extranjería',
        'CO1P': 'Pasaporte',
        'CO1V': 'Permiso Especial de Permanencia',
        'CO1W': 'Permiso por Protección Temporal'
    };

    public static homologarTipoDocuTitular(tipoDocTitular: string | number): string {
        const key = tipoDocTitular ? tipoDocTitular.toString() : '';
        return this.DOCUMENT_TIPODOC_TITULAR[key] || 'Tipo docuemnto titular desconocido'
    }


    private static readonly DOCUMENTS_TIPODOC_BENEFICIARIO: Record<string, string> = {
        'CO1L': 'Registro Civil',
        'CO1T': 'Tarjeta de identidad',
        'CO1C': 'Cédula de ciudadanía',
        'CO1D': 'Carnet Diplomático',
        'CO1E': 'Cédula de Extranjería',
        'CO1P': 'Pasaporte',
        'CO1V': 'Permiso Especial de Permanencia',
        'CO1W': 'Permiso por Protección Temporal'
    };

    public static homologarTipoDocuBeneficiario(tipoDocBeneficiario: string | number): string {
        const key = tipoDocBeneficiario ? tipoDocBeneficiario.toString() : '';
        return this.DOCUMENTS_TIPODOC_BENEFICIARIO[key] || 'Tipo documento beneficiario desconocido'
    }

}